import React, { useState, useRef, useCallback } from 'react';
import { fetchMencionaveis } from '../../api/colaboracao';

function ChamadoEditor({
    value,
    onChange,
    onInserir,
    marcado,
    onMarcadoChange,
    comentarioInterno,
    onComentarioInternoChange,
    iaHabilitada,
    onSugerirResposta,
    onReverResposta,
    onSugerirProximosPassos,
    sugestaoRespostaLoading,
    reverRespostaLoading,
    proximosPassosLoading,
    onAtualizar,
}) {
    const textareaRef = useRef(null);
    const [candidatos, setCandidatos] = useState([]);
    const [carregou, setCarregou] = useState(false);
    const [aberto, setAberto] = useState(false);
    const [query, setQuery] = useState('');
    const [inicioMencao, setInicioMencao] = useState(-1);
    const [ativo, setAtivo] = useState(0);

    const carregarCandidatos = useCallback(async () => {
        if (carregou) return;
        setCarregou(true);
        const lista = await fetchMencionaveis();
        setCandidatos(lista);
    }, [carregou]);

    // Detecta se o cursor está logo após um "@palavra" e abre o seletor.
    const detectarMencao = (texto, caret) => {
        const antes = texto.slice(0, caret);
        const m = antes.match(/(^|\s)@([\w.\-]*)$/);
        if (m) {
            setQuery(m[2] || '');
            setInicioMencao(caret - (m[2] || '').length - 1); // posição do '@'
            setAtivo(0);
            setAberto(true);
            carregarCandidatos();
        } else {
            setAberto(false);
            setInicioMencao(-1);
        }
    };

    const handleChange = (e) => {
        const novo = e.target.value;
        onChange(novo);
        const caret = e.target.selectionStart || novo.length;
        detectarMencao(novo, caret);
    };

    const filtrados = (() => {
        const q = (query || '').toLowerCase();
        const base = q
            ? candidatos.filter((c) => (c.login || '').toLowerCase().includes(q) || (c.nome || '').toLowerCase().includes(q))
            : candidatos;
        return base.slice(0, 8);
    })();

    const selecionar = (usuario) => {
        if (!usuario || inicioMencao < 0) { setAberto(false); return; }
        const caret = textareaRef.current ? (textareaRef.current.selectionStart || value.length) : value.length;
        const antes = value.slice(0, inicioMencao);
        const depois = value.slice(caret);
        const novo = `${antes}@${usuario.login} ${depois}`;
        onChange(novo);
        setAberto(false);
        setInicioMencao(-1);
        // recoloca o cursor após o login inserido
        const novaPos = (antes + '@' + usuario.login + ' ').length;
        setTimeout(() => {
            if (textareaRef.current) {
                textareaRef.current.focus();
                textareaRef.current.setSelectionRange(novaPos, novaPos);
            }
        }, 0);
    };

    const handleKeyDown = (e) => {
        if (!aberto || filtrados.length === 0) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); setAtivo((i) => Math.min(i + 1, filtrados.length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setAtivo((i) => Math.max(i - 1, 0)); }
        else if (e.key === 'Enter' || e.key === 'Tab') { e.preventDefault(); selecionar(filtrados[ativo]); }
        else if (e.key === 'Escape') { setAberto(false); }
    };

    return (
        <div className="chamado-editor">
            <div className="chamado-editor-mencao-wrap">
                <textarea
                    ref={textareaRef}
                    className="chamado-editor-textarea"
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={() => setTimeout(() => setAberto(false), 150)}
                    placeholder="Escreva uma atualização ou resposta do chamado... (use @ para mencionar)"
                    rows={4}
                />
                {aberto && filtrados.length > 0 && (
                    <ul className="chamado-mencao-lista">
                        {filtrados.map((u, idx) => (
                            <li
                                key={u.id}
                                className={`chamado-mencao-item ${idx === ativo ? 'ativo' : ''}`}
                                onMouseEnter={() => setAtivo(idx)}
                                onMouseDown={(e) => { e.preventDefault(); selecionar(u); }}
                            >
                                <span className="chamado-mencao-login">@{u.login}</span>
                                <span className="chamado-mencao-nome">{u.nome}</span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div className="chamado-editor-row">
                <button type="button" className="chamado-editor-btn chamado-editor-btn-primary" onClick={onInserir}>
                    <i className="fas fa-save" aria-hidden="true" /> Inserir
                </button>
                <label className="chamado-editor-check">
                    <input type="checkbox" checked={marcado} onChange={(e) => onMarcadoChange(e.target.checked)} />
                    Enviar email
                </label>
                <label className="chamado-editor-check">
                    <input type="checkbox" checked={comentarioInterno} onChange={(e) => onComentarioInternoChange(e.target.checked)} />
                    Comentário interno
                </label>
            </div>
            {iaHabilitada && (
                <div className="chamado-editor-ia">
                    <button type="button" className="chamado-editor-btn-ia" onClick={onSugerirResposta} disabled={sugestaoRespostaLoading}>
                        {sugestaoRespostaLoading ? 'Gerando...' : 'Sugerir resposta'}
                    </button>
                    <button type="button" className="chamado-editor-btn-ia" onClick={onReverResposta} disabled={reverRespostaLoading}>
                        {reverRespostaLoading ? 'Revisando...' : 'Revisar resposta'}
                    </button>
                    <button type="button" className="chamado-editor-btn-ia" onClick={onSugerirProximosPassos} disabled={proximosPassosLoading}>
                        {proximosPassosLoading ? 'Gerando...' : 'Sugerir próximos passos'}
                    </button>
                </div>
            )}
            <div className="chamado-editor-footer">
                <button type="button" className="chamado-editor-btn" onClick={onAtualizar} title="Atualizar">
                    <i className="fas fa-sync-alt" aria-hidden="true" />
                </button>
            </div>
        </div>
    );
}

export default ChamadoEditor;
